import React, { useState } from "react";
import { Tabs } from "antd";
import ImportForm from "./ImportForm";
import ImportHistory from "./ImportHistory";
import ImportSettings from "./ImportSettings";

const { TabPane } = Tabs;

const ImportProducts = () => {
  return (
    <div>
      <h2>Import proizvoda</h2>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Uvoz podataka" key="1">
          <ImportForm />
        </TabPane>
        <TabPane tab="Istorija uvoza" key="2">
          <ImportHistory />
        </TabPane>
        <TabPane tab="Podešavanja" key="3">
          <ImportSettings />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ImportProducts;
